import store from "@/store";
import axios from "axios";
import i18n from "@/lang";
import {
  getToken,
  removePermissionFilter,
  getPermissionFilter,
  setPermissionFilter
} from "@/utils/auth";
import { flattenDeep } from "lodash";
import { ultraViresMenu } from "@/utils/includes";
import { notification } from "iways-ui";

// const stacks = [];

// 创建axios实例
const service = axios.create({
  baseURL: "/api", // api的base_url
  timeout: 0 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    if (store.getters.token) {
      config.headers.token = store.getters.token; // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
      // 当请求为post的时候
      if (!config.data)
        config.data = { data: {}, questUID: "string", token: "" };
      if (config.url.indexOf("Token") == -1) {
        config.data.token = store.getters.token;
      }
    }
    config.params = config.params || {};
    config.params.t = new Date().valueOf();
    config.params.language = config.params.language || store.state.app.language;
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  response => {
    const { url } = response.config || {};
    const { status, data } = response.data || {};
    switch (status && status.status) {
      case "10044X":
        notification({
          title: "警告",
          dangerouslyUseHTMLString: true,
          message: `<strong>${status.msg2Dev}</strong> <a style="color: #3366FF;">点击这里</a>刷新`,
          type: "warning",
          onClick: () => {
            store.dispatch("user/refreshToken").then(() => {
              location.reload();
            });
          }
        });
        break;
      case 100440:
      case 100442:
      case 100152:
        // notification({
        //   title: "登录已过期",
        //   dangerouslyUseHTMLString: true,
        //   message: `<strong>系统即将退出，请重新登录</strong>`,
        //   type: "warning",
        //   onClose: () => {
        //     store.dispatch("user/logout").then(() => {
        //       location.reload();
        //     });
        //   }
        // });
        store.dispatch("user/logout").then(() => {
          location.href = "/";
        });
        break;
    }
    // 不需要越权页面限制处理逻辑
    if (["/api/v3/iw-framework/menu/get-all-menu"].includes(url)) {
      const newData = [];
      ultraViresMenu.forEach(item => {
        const findVal = (data || []).find(item2 => item2.id === item.id);
        if (!findVal) newData.push(item);
      });
      // 是否清空部分越权页面的缓存数据
      if (
        !newData.length ||
        !(data || []).some(item => ["/model-fastview"].includes(item.path))
      ) {
        removePermissionFilter();
      } else {
        const parseArr = JSON.parse(getPermissionFilter() || "[]");
        if (parseArr.length) {
          const mapArr = newData.map(item => {
            const str = item.path.split(":")[0];
            return parseArr.filter(item2 => {
              const str2 = "/" + item2.path?.split("/")[1];
              return str === str2;
            });
          });
          setPermissionFilter({ data: flattenDeep(mapArr) });
        }
      }

      response.data.data = [...(data || []), ...newData];
    }
    return response;
  },
  error => {
    console.log(`err${error}`); // for debug
    // redirect('/404')
  }
);

// 带缓存的请求
const cachePool = new Map();
export const requestWithCache = config => {
  const { endpoint, path, params, data } = config;
  const cacheKey = JSON.stringify({
    endpoint,
    path,
    params,
    data,
    locale: (params || {}).language || i18n.locale,
    token: getToken()
  });
  if (cachePool.has(cacheKey)) {
    const cacheKeyInfo = JSON.parse(cacheKey);
    const res = cachePool.get(cacheKey);
    console.groupCollapsed(`命中缓存：${endpoint}${path}`);
    console.info(cacheKeyInfo, res);
    console.groupEnd();
    return Promise.resolve(res);
  } else {
    return service({
      url: `${endpoint}${path}`,
      ...config
    }).then(res => {
      cachePool.set(cacheKey, res);
      return Promise.resolve(res);
    });
  }
};

export default service;
